var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 4V5.6M7.20001 4V5.6",
    stroke: "#212129",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9964 12.7998H12.0036M11.9964 15.9998H12.0036M15.1928 12.7998H15.2M8.80005 12.7998H8.80723M8.80005 15.9998H8.80723",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20001 8.7998H18.8",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40002 12.1944C4.40002 8.70856 4.40002 6.96563 5.40172 5.88272C6.40342 4.7998 8.01562 4.7998 11.24 4.7998H12.76C15.9844 4.7998 17.5967 4.7998 18.5983 5.88272C19.6 6.96563 19.6 8.70856 19.6 12.1944V12.6052C19.6 16.0911 19.6 17.834 18.5983 18.9169C17.5967 19.9998 15.9844 19.9998 12.76 19.9998H11.24C8.01562 19.9998 6.40342 19.9998 5.40172 18.9169C4.40002 17.834 4.40002 16.0911 4.40002 12.6052V12.1944Z",
    stroke: "#212129",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80005 8.7998H19.2",
    stroke: "#212129",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarInactive);
export default __webpack_public_path__ + "static/media/calendar-inactive.8520f9fc115e9217bc2258fe26ad3133.svg";
export { ForwardRef as ReactComponent };